import React from "react";
import { ProductsFilterData } from "@apollo/ops";
import { Controller, useForm } from "react-hook-form";
import { Button } from "@ui/Button";
import { AllProducersAutocomplete } from "@components/Producer/ProducerAutocomplete/ProducerAutocomplete";
import { Input } from "@components/ui/Input";

export type FilterData = ProductsFilterData;

type AdminProductsFilterProps = {
  onFilter: (data: FilterData) => void | Promise<void>;
  defaultValues?: Partial<FilterData>;
  submitText?: string;
};

export function AdminProductsFilter({
  onFilter,
  defaultValues,
}: AdminProductsFilterProps) {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    control,
  } = useForm<FilterData>({
    defaultValues,
  });

  const wrappedOnSubmit = async ({ name, ...data }: FilterData) => {
    try {
      await onFilter({
        name: name ? name : null,
        ...data,
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <form onSubmit={handleSubmit(wrappedOnSubmit)} autoComplete="off">
      <div className="grid laptop:grid-cols-3 gap-3 items-end">
        <div>
          <Controller
            name="producerId"
            control={control}
            render={({ field: { onChange, onBlur, value } }) => (
              <AllProducersAutocomplete
                label=""
                onSelect={onChange}
                onBlur={onBlur}
                selectedId={value}
                error={errors.producerId?.message}
              />
            )}
          />
        </div>
        <div>
          <Input
            id="name"
            type="text"
            {...register("name")}
            placeholder="Search product name"
          />
        </div>
        <div>
          <Button type="submit" disabled={isSubmitting} kind="secondary">
            Filter
          </Button>
        </div>
      </div>
    </form>
  );
}
